import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { AssistantService } from '@core/services/assistant/assistant.service';

import { KpiDetailCardOutletComponent } from '@shared/components/kpi-detail-card/kpi-detail-card-outlet.component';
import { ReferencePopupOutletComponent } from '@shared/components/reference-popup-outlet/reference-popup-outlet.component';

import { AssistantFilePreviewComponent } from '../assistant-panel/assistant-file/assistant-file-preview.component';
import { AssistantPanelComponent } from '../assistant-panel/assistant-panel.component';
import { EntityAutoCompleteHostComponent } from '../entities/entity-auto-complete-dialog/entity-auto-complete-host.component';
import { PlanFindingCardOutletComponent } from '../plan/finding-card/plan-finding-card-outlet.component';
import { PlanPanelComponent } from '../plan/plan-panel/plan-panel.component';
import { PlanPanelService } from '../plan/plan-panel/plan-panel.service';

@Component({
  selector: 'app-app-shell',
  imports: [
    RouterOutlet,
    EntityAutoCompleteHostComponent,
    AssistantPanelComponent,
    AssistantFilePreviewComponent,
    PlanPanelComponent,
    PlanFindingCardOutletComponent,
    ReferencePopupOutletComponent,
    KpiDetailCardOutletComponent
  ],
  templateUrl: './app-shell.component.html'
})
export class AppShellComponent {
  protected readonly assistant = inject(AssistantService);
  protected readonly planPanel = inject(PlanPanelService);
}
